import React, { useMemo } from 'react';

import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import { DocumentationCodeBlock } from '../DocumentationCodeBlock';

import { ApiOperation, ApiParameterValues } from './types';
import { codeSamples } from './utils';

const LANGUAGES = [
  { key: 'curl', label: 'cURL' },
  { key: 'python', label: 'Python' },
  { key: 'javascript', label: 'JavaScript' },
] as const;

/** Ready-to-copy requests that follow the values entered in Try it. */
export const ApiCodeSamples = ({
  operation,
  values,
}: {
  operation: ApiOperation;
  values: ApiParameterValues;
}) => {
  const samples = useMemo(
    () => codeSamples(operation, window.location.origin, values),
    [operation, values],
  );
  return (
    <Tabs variant="line" colorScheme="purple" size="sm" isLazy>
      <TabList>
        {LANGUAGES.map(({ key, label }) => (
          <Tab key={key} fontWeight={400}>
            {label}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {LANGUAGES.map(({ key }) => (
          <TabPanel key={key} px={0} pb={0}>
            <DocumentationCodeBlock code={samples[key]} />
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};
